import type { ClipUploadFile } from "@components/ClipUpload/ClipUpload";
import type { CharacterAssetCreateFormRequestCategory } from "@apis/generated/openapi";

/** Modal 三种创建模式（与 Product 入口的 CreateMethodDropdown 保持对称） */
export type CreateCharacterMode = "videoLink" | "library" | "manual";
/** Modal 内部子态：input 子态用于 link / library；editor 是表单 */
export type CreateCharacterStep = "input" | "editor";

/** 表单聚合状态（图片放在 imageFiles 里独立维护） */
export interface CharacterFormState {
  category: CharacterAssetCreateFormRequestCategory;
  name: string;
}

export interface CreateCharacterEntityModalProps {
  open: boolean;
  onClose: () => void;
  /** 创建或改名成功 */
  onSuccess?: () => void;
  /** 编辑态时传入角色资产 ID；不传则为新建 */
  characterId?: number | null;
  /** 默认分类：从外部 sub-tab 决定打开哪种角色 */
  defaultCategory?: CharacterAssetCreateFormRequestCategory;
  /** 默认选哪种创建模式打开，缺省为 manual */
  defaultMode?: CreateCharacterMode;
}

/** 主图必传，其他视角图最多 3 张（PRD 4.1） */
export const MAX_OTHER_CHARACTER_IMAGES = 3;
/** 角色名最大字符数（PRD 4.1） */
export const CHARACTER_NAME_MAX_LENGTH = 50;
/** ClipUpload 文件类型直接复用，不挂业务 response */
export type CharacterImageFile = ClipUploadFile;

/** 兼容外部 enum，方便业务层统一引用 */
export type CharacterCategory = CharacterAssetCreateFormRequestCategory;
